import React, { createContext, useEffect, useReducer, useState, useRef } from "react";
import { makeStyles } from '@mui/styles';
import conversationReducer from "./conversationReducer";
import ChatbotHandler from "./Handlers/ChatbotHandler";
import Footer from "./Footer";
import Header from "./Header";
import MessagesList from "./MessagesList";
import ClickToCall from "../ClickToCall";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      overflow: "hidden"
    }
  },
  chatbotWrapper: {
    backgroundColor: "#ffffff",
    height: "100%",
    width: "100%",
    position: "relative"
  },
  // chatbotBg: {
  //     position: "absolute",
  //     top: 0,
  //     left: 0,
  //     width: "100%",
  //     height: "100%",
  // },
  // chatbotBgSvg: {
  //     width: "100%",
  //     height: "100%",
  // },
  chatbotContainer: {
    height: "100%",
    width: "100%",
    maxWidth: 890,
    margin: "0 auto",
    paddingBottom: theme.spacing(2.5)
  }
}));

const ConversationContext = createContext({});

function Chatbot({ initialMessage }) {
  const [conversation, conversationDispatch] = useReducer(conversationReducer, []);
  const [chatbotHandler, setChatbotHandler] = useState({});
  const [inputPlaceholder, setInputPlaceholder] = useState("Type a message...");
  const [inputDisabled, setInputDisabled] = useState(true);
  const clickToCallRef = useRef();

  // Connect to socket only once, cleanup by disconnecting from socket.
  useEffect(() => {
    let handler = new ChatbotHandler(conversationDispatch, initialMessage, {
      setInputDisabled
    });
    setChatbotHandler(handler);
    return () => handler.leaveRoom();
  }, []);

  const setInputPlaceholderText = () => setInputPlaceholder("Type your message here...");
  const setInputPlaceholderOption = () => setInputPlaceholder("Select an option...");

  const classes = useStyles();
  return (
    <ConversationContext.Provider
      value={{
        chatbotHandler,
        setInputPlaceholderOption,
        setInputPlaceholderText,
        clickToCallRef
      }}
    >
      <ClickToCall
        ref={clickToCallRef}
        onCallDisconnect={() => chatbotHandler.businessDevelopmentCallDisconnected()}
      />
      <div className={classes.chatbotWrapper}>
        {/* <div className={classes.chatbotBg}>
                    <ChatBotBackground/>
                </div> */}
        <Header />
        <div className={classes.chatbotContainer}>
          <MessagesList conversation={conversation} />
          <Footer placeholder={inputPlaceholder} inputDisabled={inputDisabled} />
        </div>
      </div>
    </ConversationContext.Provider>
  );
}

export default Chatbot;
export { ConversationContext };
